import { render, staticRenderFns } from "./TqCheckbox.vue?vue&type=template&id=2d6c4337&scoped=true&"
import script from "./TqCheckbox.vue?vue&type=script&lang=js&"
export * from "./TqCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./TqCheckbox.vue?vue&type=style&index=0&id=2d6c4337&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6c4337",
  null
  
)

export default component.exports